/**
 * Created by jonas on 2023-09-04.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class KitchenDramaScalingLayer extends PIXI.Container implements StageLayer{
    private layers:StageLayer[] = [];

    constructor() {
        super();
        this.name = "KitchenDramaScalingLayer";
    }

    onResize():void {
        for (let layer of this.layers){
            if (layer.onResize){
                layer.onResize();
            }
        }
        let newScale = 1;
        let margin = 0;

        console.log(NolimitApplication.screenBounds);

        if (NolimitApplication.isLandscape){
            let ratio = NolimitApplication.screenBounds.width / 1200;
            if (ratio < 1){
                newScale = ratio;
                margin = NolimitApplication.screenBounds.left + (240 * ratio);
            }
        }



        this.position.set(margin, margin);
        this.scale.set(newScale, newScale);
    }

    onOrientationChanged():void {
        for (let layer of this.layers){
            if (layer.onOrientationChanged){
                layer.onOrientationChanged();
            }
        }
    }




    addLayerAt(name:string, layer:StageLayer, index:number) {
        this.layers.push(layer);
        this.addChildAt(layer, index);
    }
}